// extracted by mini-css-extract-plugin
export default {"button":"Buttom_button__8HnqM"};